var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SectorButton from '../projects/SectorButton.vue';
import Pager from '../shared/Pager.vue';
import Loader from '../shared/Loader.vue';
import Cta from '../shared/Cta.vue';
import SocialLink from '../shared/SocialLink.vue';
import Choices from 'choices.js';
const service = namespace('Service');
let VideosList = class VideosList extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.noResult = false;
        this.data = [];
        this.pageLoading = false;
        this.activeSectorId = 0;
        this.currentPage = 1;
        this.numberOfPage = 0;
        this.itemPerPage = 12;
        this.args = {};
        this.filterSelect = null;
        this.selectProps = {
            searchEnabled: false,
            shouldSort: false,
            placeholder: true,
            placeholderValue: '',
            itemSelectText: '',
        };
    }
    created() {
        this.args = {
            siteId: window.cibbic.siteId,
            relatedToCategories: this.activeSector ? this.activeSector.id : null,
            limit: this.itemPerPage,
        };
        this.getVideos(this.args);
        if (this.activeSector) {
            this.activeSectorId = this.activeSector.id;
        }
    }
    mounted() {
        this.selectProps.noResultsText = this.labels.noResultsText;
        this.selectProps.noChoicesText = this.labels.noChoicesText;
        this.filterSelect = new Choices('#sectorFilter', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'sectorFilterLabel' }));
        if (this.sectors.length > 0) {
            this.fillSectorsDropDown();
        }
    }
    getSectorString(sectors) {
        return sectors.map((s) => { return s.title; }).join(' | ');
    }
    onSectorClicked(sector) {
        if (sector) {
            window.location.href = '//' + window.location.host + (window.cibbic.siteId == 2 ? '/fr/medias/videos/' + sector.url : '/en/media/videos/' + sector.url);
        }
        else if (this.activeSectorId != 0) {
            window.location.href = this.overviewUrl;
        }
    }
    onPageChange(value) {
        this.pageLoading = true;
        this.args.offset = (value - 1) * this.itemPerPage;
        this.getVideos(this.args);
    }
    onSectorFilterChanged(evt) {
        if (evt.detail.value === 0) {
            this.onSectorClicked(null);
        }
        else {
            let sector = this.sectors.find((s) => { return s.id === evt.detail.value; });
            this.onSectorClicked(sector);
        }
    }
    fillSectorsDropDown() {
        var _a;
        let tmp = this.sectors.map((i) => {
            return { value: i.id, label: i.title, selected: this.activeSectorId == i.id };
        });
        tmp.unshift({ value: 0, label: this.labels.all_sectors, selected: this.activeSectorId === 0 });
        (_a = this.filterSelect) === null || _a === void 0 ? void 0 : _a.setChoices(tmp, 'value', 'label', true);
    }
    onvideosData(value) {
        this.noResult = false;
        this.data = this.videosData.videos || [];
        if (this.data.length > 0) {
            this.numberOfPage = Math.ceil(this.itemCount / this.itemPerPage);
            setTimeout(() => {
                this.pageLoading = false;
            }, 100);
            if (window.scrollY > 0) {
                document.querySelector('#videos-list-component').scrollIntoView({
                    behavior: "smooth",
                });
            }
        }
        else if (this.data.length === 0 && this.videosData.videos !== undefined) {
            this.pageLoading = false;
            this.noResult = true;
        }
    }
    onSectors() {
        this.fillSectorsDropDown();
        this.loading = false;
    }
};
__decorate([
    Prop({ type: Object })
], VideosList.prototype, "labels", void 0);
__decorate([
    Prop({ type: Object })
], VideosList.prototype, "activeSector", void 0);
__decorate([
    Prop()
], VideosList.prototype, "overviewUrl", void 0);
__decorate([
    service.State
], VideosList.prototype, "videosData", void 0);
__decorate([
    service.State
], VideosList.prototype, "sectors", void 0);
__decorate([
    service.State
], VideosList.prototype, "itemCount", void 0);
__decorate([
    service.Action
], VideosList.prototype, "getVideos", void 0);
__decorate([
    Watch('videosData')
], VideosList.prototype, "onvideosData", null);
__decorate([
    Watch('sectors')
], VideosList.prototype, "onSectors", null);
VideosList = __decorate([
    Component({
        components: {
            SectorButton,
            Pager,
            Loader,
            SocialLink,
            Cta
        }
    })
], VideosList);
export default VideosList;
